import { Field, ActionField } from '@oscar/form';
import { Button, Col, Form, Input, InputNumber, Row } from '@oscar/theme';
import { TextField } from 'common/components';
import { filter } from 'lodash';
import React, { useMemo } from 'react';
import { numberAndSpecialCharacters } from 'utils/normalize';
import './style.scss';

interface Props {
  name: string | string[];
  title?: string;
  readOnly?: boolean;
  keyField?: string;
  masterData: any;
  dependencies?: {
    coatingSystemId: number;
    environmentId: number;
    serviceCategoryId: number;
    systemId: number;
  };
}

export interface Coat {
  coat: number;
  specification: 'string';
  nominal: number;
  surfaceProfile: 'string';
}

const initialValues = [{}, {}, {}, {}, {}];

const EditField: React.FC<{ name: string | any; readOnly?: boolean }> = ({
  name,
  readOnly,
}) => {
  return (
    <Form.List name={name} initialValue={initialValues}>
      {(fields, { add, remove }, { errors }) => (
        <>
          {fields.map((field: any, index: number) => {
            return (
              <Row className="coat-item" key={field.name}>
                <Col span={2}>
                  <TextField label="" value={index + 1} />
                </Col>
                <Col span={readOnly ? 10 : 8}>
                  <Field
                    name={[field.name, 'specification']}
                    fieldKey={[field.name, 'specification']}
                  >
                    {readOnly ? (
                      <TextField label="" />
                    ) : (
                      <Input
                        size="middle"
                        maxLength={40}
                        style={{ width: '60%' }}
                      />
                    )}
                  </Field>
                </Col>
                <Col span={6}>
                  <Field
                    {...field}
                    name={[field.name, 'nominal']}
                    fieldKey={[field.name, 'nominal']}
                  >
                    {readOnly ? (
                      <TextField label="" />
                    ) : (
                      <InputNumber
                        maxLength={8}
                        size="middle"
                        style={{ width: '60%' }}
                      />
                    )}
                  </Field>
                </Col>
                <Col span={6}>
                  <Field
                    {...field}
                    fieldKey={[field.name, 'surfaceProfile']}
                    name={[field!.name, 'surfaceProfile']}
                    getValueProps={numberAndSpecialCharacters}
                  >
                    {readOnly ? (
                      <TextField label="" />
                    ) : (
                      <Input
                        maxLength={8}
                        size="middle"
                        style={{ width: '60%' }}
                      />
                    )}
                  </Field>
                </Col>
                {!readOnly && (
                  <Col span={2}>
                    <Button
                      size="small"
                      type="primary"
                      onClick={() => {
                        if (field) {
                          remove?.(field?.name);
                        }
                      }}
                    >
                      Remove
                    </Button>
                  </Col>
                )}
              </Row>
            );
          })}
          {!readOnly && (
            <Row>
              <ActionField
                name="resetValues"
                request={{
                  name: 'resetValues',
                }}
              >
                {(actionProps: any) => {
                  return (
                    <Button
                      size="small"
                      className="reset-button"
                      onClick={() =>
                        actionProps?.field?.setFieldsValue({
                          [name]: initialValues,
                        })
                      }
                    >
                      Reset
                    </Button>
                  );
                }}
              </ActionField>
            </Row>
          )}
        </>
      )}
    </Form.List>
  );
};

const CoatList: React.FC<Props> = ({
  title,
  name,
  readOnly,
  masterData,
  dependencies,
}) => {
  const data = useMemo(() => {
    return filter(masterData, dependencies);
  }, [dependencies, masterData]);
  return data.length > 0 || dependencies?.systemId === 69 ? (
    <div className="coat-list">
      <Row className="coat-header">
        <Col span={2}>Coat</Col>
        <Col span={dependencies?.systemId !== 69 || readOnly ? 10 : 8}>
          Paint and Coating Specification
        </Col>
        <Col span={6}>Norminal</Col>
        <Col span={6}>Surface Profile</Col>
      </Row>
      {dependencies?.systemId !== 69 ? (
        data.map(item => (
          <Row className="coat-item" key={item?.coat}>
            <Col span={2}>
              <TextField label="" value={item?.coat} />
            </Col>
            <Col span={10}>
              <TextField label="" value={item?.specification} />
            </Col>
            <Col span={6}>
              <TextField label="" value={item?.nominal} />
            </Col>
            <Col span={6}>
              <TextField label="" value={item?.surfaceProfile} />
            </Col>
          </Row>
        ))
      ) : (
        <EditField name={name} readOnly={readOnly} />
      )}
    </div>
  ) : null;
};
export default CoatList;
